module.exports = __webpack_public_path__ + "media/images/icons/file-error-852be0ac27761debd397d4a0fc09eb72.svg";